module.exports = __webpack_public_path__ + "static/finovate-spring-2016-07257457cdc7eb09b94a297e472d6130.png";